window.__CONFIG__ = {
  INHOUSE_AUTHENTICATION_ENABLED: import.meta.env
    .VITE_INHOUSE_AUTHENTICATION_ENABLED,
};
